module.exports = __webpack_public_path__ + "img/amex.9054612f.svg";